/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReferralRecipientInput
 */
export interface ReferralRecipientInput {
    /**
     * Recipient identifier — either a real provider_directory row or a hardcoded allowlist facility's synthetic id. Omit entirely for an "other" recipient (a name+email contact not backed by either).
     */
    provider_id?: string;
    /**
     * The referral_recipient_config's own id. Required when provider_id is omitted — this (not email) is an "other" recipient's routing identity downstream, since email alone isn't safe to expose as a URL/analytics-visible identifier.
     */
    recipient_config_id?: string;
    /**
     * 
     */
    email?: string;
    /**
     * Recipient name. Required when provider_id is omitted.
     */
    display_name?: string;
}

/**
 * Check if a given object implements the ReferralRecipientInput interface.
 */
export function instanceOfReferralRecipientInput(value: object): value is ReferralRecipientInput {
    return true;
}

export function ReferralRecipientInputFromJSON(json: any): ReferralRecipientInput {
    return ReferralRecipientInputFromJSONTyped(json, false);
}

export function ReferralRecipientInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralRecipientInput {
    if (json == null) {
        return json;
    }
    return {
        
        'provider_id': json['provider_id'] == null ? undefined : json['provider_id'],
        'recipient_config_id': json['recipient_config_id'] == null ? undefined : json['recipient_config_id'],
        'email': json['email'] == null ? undefined : json['email'],
        'display_name': json['display_name'] == null ? undefined : json['display_name'],
    };
}

export function ReferralRecipientInputToJSON(json: any): ReferralRecipientInput {
    return ReferralRecipientInputToJSONTyped(json, false);
}

export function ReferralRecipientInputToJSONTyped(value?: ReferralRecipientInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'provider_id': value['provider_id'],
        'recipient_config_id': value['recipient_config_id'],
        'email': value['email'],
        'display_name': value['display_name'],
    };
}

